import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const clientPanelGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const userItem = sessionStorage.getItem('user');
  const user = userItem ? JSON.parse(userItem) : null;

  if (user.authorities.some((item: string) =>
    item === 'ROLE_USER' ||
    item === 'ROLE_MASTERBOI_PROVIDER' ||
    item === 'ROLE_ASSAI_PROVIDER'
    ) && !user.confirmPersonalData
  ) {
    return true;
  }
  router.navigate(['/login']);
  return false;
};

export const clientPublicGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const userItem = sessionStorage.getItem('user');
  const user = userItem ? JSON.parse(userItem) : null;

  if (user.authorities.some((
    item: string) => item === 'ROLE_USER' ||
    item === 'ROLE_MASTERBOI_PROVIDER' ||
    item === 'ROLE_ASSAI_PROVIDER'
  )) {
    return true;
  }
  router.navigate(['/login']);
  return false;
};
